import { ApiSchemas } from '..'
import { wrapEndpoint } from '../wrap'
import { client } from '../client'

export default {
  async list(query?: ApiSchemas['ListTreatmentActionMechanismDto']) {
    return wrapEndpoint(() =>
      client.GET('/treatment-action-mechanism', {
        params: {
          query,
        },
      }),
    )
  },
}
